<template>
    <div class="alert alert-dismissible fade show" role="alert" :class="is_error?'alert-danger':'alert-success'" v-if="msg != ''">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-if="is_error">
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Msg',
    props:{
        message: '',
        is_error: false
    },
    data () {
        return {
            msg:''
        }
    },
    mounted() {
    },
    watch: {
        message:function() {
            console.log(this.message);
            this.msg = this.message;
            if ( !this.is_error ) {
                var vm = this;
                setTimeout(function(){ vm.msg = '', vm.$emit('callback', true);  }, 2000);
            }
        } 
    },
    methods: {
    }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/Msg.vue